import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'app-secure-visitorDashboardcopycopy',
  templateUrl: './visitorDashboardcopycopy.component.html',
  styleUrls: ['./visitorDashboardcopycopy.component.scss'],
})
export class visitorDashboardcopycopyComponent implements OnInit {
 
  
  constructor(

  ) {}
  ngOnInit(): void {
    throw new Error("Method not implemented.");
  }

  
  
  
  
  }
